"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpecialFunctionData = exports.getSpecialFnType = void 0;
const sheet_db_1 = require("../../sheet_db");
const custom_tree_1 = require("../custom_tree");
const foreign_node_1 = require("../custom_tree/foreign.node");
const getSpecialFnType = (node) => {
    if (!node?.formulaDef?.special_fn_type)
        throw new Error(`Invalid special function: ${node?.formulaName}`);
    return node.formulaDef.special_fn_type;
};
exports.getSpecialFnType = getSpecialFnType;
const aggregationTypeMap = new Map([
    ['SUMIFS', 'SUM'],
    ['MAXIFS', 'MAX'],
    ['MINIFS', 'MIN'],
    ['COUNTIFS', 'COUNT'],
]);
const getRealOperator = (node, shouldInvertOperator) => {
    if (!(node instanceof custom_tree_1.SymbolNode))
        throw new Error('Expecting comparison middle child to be symbol node');
    const op = node.abstractText?.trim();
    if (!Object.values(sheet_db_1.ComparisonType).includes(op))
        throw new Error('Invalid operator ' + op);
    const inverseMap = new Map([
        ['>', '<='],
        ['>=', '<'],
        ['<', '>='],
        ['<=', '>'],
    ]);
    const operator = shouldInvertOperator ? inverseMap.get(op) ?? op : op;
    return operator;
};
const getAggregationConditionData = (comparison) => {
    // The boolean comparison must be in the left side of the comparison
    const shouldInvertOperator = comparison.children[2] instanceof foreign_node_1.ForeignNode;
    const operator = getRealOperator(comparison.children[1], shouldInvertOperator);
    const leftComparisonSide = shouldInvertOperator ? comparison.children[2] : comparison.children[0];
    const rightComparisonSide = shouldInvertOperator
        ? comparison.children[0]
        : comparison.children[2];
    if (!(leftComparisonSide instanceof foreign_node_1.ForeignNode))
        throw new Error('Invalid boolean condition');
    const foreignColId = leftComparisonSide.column?.column_id ?? leftComparisonSide.columnToken;
    if (rightComparisonSide instanceof custom_tree_1.ConstantNode) {
        const rawValue = rightComparisonSide.value;
        return {
            type: sheet_db_1.FormulaComparisonType.RANGE_AND_CONSTANT,
            foreignColId,
            operator,
            rawValue,
        };
    }
    else if (rightComparisonSide instanceof custom_tree_1.ColumnNode) {
        const column_id = rightComparisonSide.column?.column_id ?? rightComparisonSide.abstractText;
        return {
            type: sheet_db_1.FormulaComparisonType.RANGE_AND_COLUMN,
            foreignColId,
            operator,
            column_id,
        };
    }
    throw new Error("Invalid boolean condition");
};
const getAggregationData = (node) => {
    const aggType = aggregationTypeMap.get(node.translatedFormulaName);
    if (!aggType)
        throw new Error("Aggregation type not mapped for function " + node.formulaName);
    const firstArg = node.children[0];
    if (!(firstArg instanceof foreign_node_1.ForeignNode))
        throw new Error('Expecting first child to be instance of ForeignNode');
    const foreignTabId = firstArg.tab?.id ?? firstArg.tabToken;
    const aggregationColId = firstArg.column?.column_id ?? firstArg.columnToken;
    const conditions = node.children.slice(1).map(arg => {
        if (!(arg instanceof custom_tree_1.ComparisonExprNode))
            throw new Error('Expecting all other args to be boolean comparison');
        return getAggregationConditionData(arg);
    });
    return {
        fnType: 'aggregation',
        foreignTabId,
        aggregationColId,
        aggType,
        conditions,
    };
};
const getRollingSumData = (node) => {
    const args = node.children;
    const valueToSum = args[0] instanceof custom_tree_1.ColumnNode ? args[0].column : args[0].value;
    const repeatingValue = args[1] instanceof custom_tree_1.ColumnNode ? args[1].column : args[1].value;
    const orderBy = args[2].column;
    const orderType = args[3].value;
    return {
        fnType: 'rolling_sum',
        valueToSum,
        orderBy,
        orderType,
        repeatingValue,
    };
};
const getSpecialFunctionData = (node) => {
    if (!node.formulaData)
        throw new Error('Calling without formula data');
    const handlers = new Map([
        ['aggregation', getAggregationData],
        ['rolling_sum', getRollingSumData],
    ]);
    const type = (0, exports.getSpecialFnType)(node);
    const handler = handlers.get(type);
    return handler(node);
};
exports.getSpecialFunctionData = getSpecialFunctionData;
